import { cn } from "@/lib/utils";

const DEFAULT_COPYRIGHT = "© {year} Vertoz. All rights reserved.";

/**
 * Copyright line from VITE_COPYRIGHT_TEXT ("{year}" becomes the current year). Unset uses the
 * default; set to an empty value to hide it.
 */
const copyrightText = () => {
  const text = import.meta.env.VITE_COPYRIGHT_TEXT ?? DEFAULT_COPYRIGHT;
  return String(text).trim().replace(/\{year\}/g, String(new Date().getFullYear()));
};

export default function CopyrightFooter({ className }: { className?: string }) {
  const text = copyrightText();
  if (!text) return null;
  return <footer className={cn("px-6 py-3 text-center text-xs text-gray-500", className)}>{text}</footer>;
}
